/**
 * In diesem File werden die Punkte zu den Anworten der einzelnen Module definiert.
 * Mehr zur Punktevergabe:
 * https://pflegede.atlassian.net/wiki/spaces/EGS/pages/886571039/Auswertungsgrundlage+Dokumente+Pflegegradrechner
 */

// import modules from './modules';

const points1 = [0, 1, 2, 3];
const points2 = [0, 1, 3, 5];

const points = [
  /**
   * Modul 1:
   * 5 Fragen
   */
  {
    0: points1,
    1: points1,
    2: points1,
    3: points1,
    4: points1,
  },

  /**
   * Modul 2:
   * 11 Fragen
   */
  {
    0: points1,
    1: points1,
    2: points1,
    3: points1,
    4: points1,
    5: points1,
    6: points1,
    7: points1,
    8: points1,
    9: points1,
    10: points1,
  },

  /**
   * Modul 3:
   * 13 Fragen
   */
  {
    0: points2,
    1: points2,
    2: points2,
    3: points2,
    4: points2,
    5: points2,
    6: points2,
    7: points2,
    8: points2,
    9: points2,
    10: points2,
    11: points2,
    12: points2,
  },

  /**
   * Modul 4:
   * 13 Fragen
   */
  {
    0: points1,
    1: points1,
    2: points1,
    3: points1,
    4: points1,
    5: points1,
    6: points1,
    7: [0, 3, 6, 9],
    8: [0, 2, 4, 6],
    9: [0, 2, 4, 6],
    10: points1,
    11: points1,
    12: [0, 3, 6],
  },

  /**
   * Modul 5
   */
  {},

  /**
   * Modul 6:
   * 6 Fragen
   */
  {
    0: points1,
    1: points1,
    2: points1,
    3: points1,
    4: points1,
    5: points1,
  },
];

/**
 * Dieses Array spiegelt die Bewertungssystematik
 * Tabelle im Confluence Dokumente wieder
 */

const ratingPoints = [
  /**
   * Modul 1
   */
  [
    {
      from: 0,
      to: 1,
      gewichtet: 0,
    },
    {
      from: 2,
      to: 3,
      gewichtet: 2.5,
    },
    {
      from: 4,
      to: 5,
      gewichtet: 5,
    },
    {
      from: 6,
      to: 9,
      gewichtet: 7.5,
    },
    {
      from: 10,
      to: 15,
      gewichtet: 10,
    },
  ],

  /**
   * Modul 2
   */
  [
    {
      from: 0,
      to: 1,
      gewichtet: 0,
    },
    {
      from: 2,
      to: 5,
      gewichtet: 3.75,
    },
    {
      from: 6,
      to: 10,
      gewichtet: 7.5,
    },
    {
      from: 11,
      to: 16,
      gewichtet: 11.25,
    },
    {
      from: 17,
      to: 33,
      gewichtet: 15,
    },
  ],

  /**
   * Modul 3
   */
  [
    {
      from: 0,
      to: 0,
      gewichtet: 0,
    },
    {
      from: 1,
      to: 2,
      gewichtet: 3.75,
    },
    {
      from: 3,
      to: 4,
      gewichtet: 7.5,
    },
    {
      from: 5,
      to: 6,
      gewichtet: 11.25,
    },
    {
      from: 7,
      to: 65,
      gewichtet: 15,
    },
  ],

  /**
   * Modul 4
   */
  [
    {
      from: 0,
      to: 2,
      gewichtet: 0,
    },
    {
      from: 3,
      to: 7,
      gewichtet: 10,
    },
    {
      from: 8,
      to: 18,
      gewichtet: 20,
    },
    {
      from: 19,
      to: 36,
      gewichtet: 30,
    },
    {
      from: 37,
      to: 54,
      gewichtet: 40,
    },
  ],

  /**
   * Modul 5
   */
  [
    {
      from: 0,
      to: 0.99,
      gewichtet: 0,
    },
    {
      from: 1,
      to: 1.99,
      gewichtet: 5,
    },
    {
      from: 2,
      to: 3.99,
      gewichtet: 10,
    },
    {
      from: 4,
      to: 5.99,
      gewichtet: 15,
    },
    {
      from: 6,
      to: 16,
      gewichtet: 20,
    },
  ],

  /**
   * Modul 6
   */
  [
    {
      from: 0,
      to: 0,
      gewichtet: 0,
    },
    {
      from: 1,
      to: 3,
      gewichtet: 3.75,
    },
    {
      from: 4,
      to: 6,
      gewichtet: 7.5,
    },
    {
      from: 7,
      to: 11,
      gewichtet: 11.25,
    },
    {
      from: 12,
      to: 18,
      gewichtet: 15,
    },
  ],
];

export { ratingPoints };
export default points;
